import { Component, ElementRef, Inject, OnInit, ViewChild, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import {SPdfViewerComponent} from './s-pdf-viewer/s-pdf-viewer.component';
import {SImgViewerComponent} from './s-img-viewer/s-img-viewer.component';
@Component({
  selector: 'app-s-file-viewer',
  templateUrl: './s-file-viewer.component.html',
  styleUrls: ['./s-file-viewer.component.less']
})
export class SFileViewerComponent implements OnInit {

  @ViewChild('host', { read: ViewContainerRef }) host: ViewContainerRef;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
  ) { }

  ngOnInit(): void {
  }

  handleView(type, src) {
    this.host.clear();
    let componentRef;
    if (type === 'jpeg') {
      const imgComponentFactory = this.componentFactoryResolver.resolveComponentFactory(SImgViewerComponent);
      componentRef = this.host.createComponent(imgComponentFactory);
      (componentRef.instance as SImgViewerComponent).src = src;
      return;
    } else if (type === 'pdf' || type === 'word' || type === 'excel' || type === 'ppt') {
      const pdfComponentFactory = this.componentFactoryResolver.resolveComponentFactory(SPdfViewerComponent);
      componentRef = this.host.createComponent(pdfComponentFactory);
      (componentRef.instance as SPdfViewerComponent).src = src;
      return;
    }
  }
}
